// extracted by mini-css-extract-plugin
export default {"docList":"docs_docList__JDvsD","item":"docs_item__XPP2A","docData":"docs_docData__xWErV","docTitle":"docs_docTitle__hnB9d","docInfo":"docs_docInfo__oHPjY"};